import request from "../utils/request";
export function getStreet() {
  return request.get("/api/base/getSelect");
}
export function getTown() {
  return request.get("/api/base/gettownList");
}
export function getloadselect() {
  return request.get("/api/base/getloadselect");
}
export function fangjiact(data) {
  return request.post("/api/base/savect", data);
}
export function fangjia(data) {
  return request.post("/api/base/save", data);
}
export function fangjiawp(data) {
  return request.post("/api/base/savewp", data);
}
export function fangjiazp(data) {
  return request.post("/api/base/savezp", data);
}
export function fangdai(data) {
  return request.post("/api/load/save", data);
}
export function fangdaiwp(data) {
  return request.post("/api/load/savewp", data);
}
export function sendCode(data) {
  return request.get("/api/base/code", data);
}
export function loadLog(data) {
  return request.get("/api/user/loadlog", data);
}
export function bindsave(data) {
  return request.post("/api/base/bindsave", data);
}


export function getWxUser(data) {
  return request.post("/app/oauth/qywx/login/" + data, data);
}
export function getAreaList() {
  return request.get("/app/business/area/list");
}

export function getVillageList(data) {
  return request.get("/app/business/village/list/" + data);
}

export function save(data) {
  return request.post("/app/business/save", data);
}

export function getUserConfig() {
  return request.get("/app/business/userinfo");
}

export function getQueryList() {
  return request.get("/app/business/query/list");
}

export function getRecordById(data) {
  return request.get("/app/business/query/record/" + data);
}

export function getDeptList() {
  return request.get("/app/business/dept/list");
}
export function loadSave(data) {
  return request.post("/app/business/load/save", data);
}

export function getLoadList() {
  return request.get("/app/business/load/list");
}